<template>
  <v-row
    :class="classRow"
    :align="align"
    :justify="justify"
  >
    <v-col
      cols="12"
    >
      <h3
        :class="classTitle"
      >
        <v-icon
          v-if="iconprincipal"
          class="mr-5"
          color="primary"
        >
          {{ iconprincipal }}
        </v-icon>
        {{ title }}
      </h3>
      <template v-if="lines && lines.literal">
        <P
          :class="classBody"
        >
          <v-icon
            v-if="iconline"
            class="mr-5"
            color="primary"
          >
            {{ iconline }}
          </v-icon>
          <strong>{{ lines.literal }}</strong>
        </P>
      </template>

      <template v-if="lines && lines.literalExtend.length">
        <P
          v-for="(line, n) in lines.literalExtend"
          :key="n"
          :class="claseLinea"
        >
          <v-icon
            v-if="iconline && !lines.literal"
            class="mr-5"
          >
            {{ iconline }}
          </v-icon>

          <v-icon
            v-else
            size="0.8em"
            class="ml-5 mr-5"
          >
            mdi-adjust
          </v-icon>
          {{ line }}
        </P>
      </template>
    </v-col>
  </v-row>
</template>

<script>
  import Heading from './Heading'

  export default {
    name: 'BaseSubtitle',

    extends: Heading,

    props: {
      classRow: {
        type: String,
        default: 'mt-5',
      },
      align: {
        type: String,
        default: 'start',
      },
      justify: {
        type: String,
        default: 'center',
      },
      classTitle: {
        type: String,
        default: 'title font-weight-bold mb-4 text-left',
      },
      classBody: {
        type: String,
        default: 'base-body body-1 grey--text text--darken-1 text-left ml-5',
      },
      iconprincipal: {
        type: String,
        default: null,
      },
      iconline: {
        type: String,
        default: null,
      },
      title: {
        type: String,
        default: '',
      },
      lines: {
        type: Object,
        default: null,
      },
    },

    computed: {
      claseLinea () {
        let result = 'base-body body-1 grey--text text--darken-1 text-left ml-5'
        if (this.lines.literal) {
          result = 'base-body body-1 grey--text text--darken-1 text-left ml-10'
        }
        return result
      },
    },
  }
</script>
